import axios from 'axios'
import qs from 'qs'
import router from '@/router'
import { Message, MessageBox } from 'element-ui'

const service = axios.create({
    //baseURL: 'https://4135d8f9-23d5-4e48-8f67-d2accfad4d59.bspapp.com/http/',  // api的base_url process.env.BASE_URL
	// baseURL: 'http://10.10.45.50:8001/api/',	// 长沙师范学院 内部域名
	// baseURL: 'http://10.0.13.90:8001/api/',	// 广东技术师范大学 内部域名
	// 打包使用地址
	baseURL: 'http://zb.gnszkj.com/',
	// baseURL: 'http://10.0.0.132:1204/',
    timeout: 50000  // 请求超时时间
});

/****** request拦截器==>对请求参数做处理 ******/
service.interceptors.request.use(config => {
    // app.$vux.loading.show({
    //     text: '数据加载中……'
    // });
	console.log('进接口了')
	console.log(config)
    // config.method === 'post' ? config.data = qs.stringify({...config.data}) : config.params = {...config.params};

	// config.method === 'post' ? config.data = {...config.data} : config.params = {...config.data};

	// config.data = {
	// 	confrimPassword: "111111",
	// 	password: "111111",
	// 	username: "13244221111"
	// }
	// config.data = JSON.stringify(config.data)

	console.log(config.data)
	console.log(config.params)
	let token = localStorage.getItem("token")?localStorage.getItem("token"):''
	console.log(token)
	if(token){
		config.headers['Authorization'] = 'bearer ' + token
	}


	// config.headers['Content-Length'] = 64;
    // config.headers['Content-Type'] = 'application/json';

    return config;
}, error => {  //请求错误处理
    // app.$vux.toast.show({
    //     type: 'warn',
    //     text: error
    // });
    Promise.reject(error)
});

/****** respone拦截器==>对响应做处理 ******/
service.interceptors.response.use(
    response => {  //成功请求到数据
        // app.$vux.loading.hide();
        //这里根据后端提供的数据进行对应的处理
		console.log(response)
        if (response.data.code == 200||response.data.errno == 200||response.data.success == true) {
			console.log('成功调用')
            return response.data;
        } else {
            // Message({
            //   message: response.data.message,
            //   type: 'error',
            //   duration: 3000
            // })
			return response.data;

        }
    },
    error => {  //响应错误处理
        console.log('error');
        console.log(error);
        console.log(JSON.stringify(error));
		console.log(JSON.parse(JSON.stringify(error)))
		if(JSON.parse(JSON.stringify(error)).message.indexOf(401)!=-1 || (JSON.parse(JSON.stringify(error)).response&&JSON.parse(JSON.stringify(error)).response.status == 401)){
			window.localStorage.clear()
			location.reload()
		}

        // let text = JSON.parse(JSON.stringify(error)).response.status === 404
        //     ? '404'
        //     : '网络异常，请重试';
        // app.$vux.toast.show({
        //     type: 'warn',
        //     text: text
        // });



        return Promise.reject(error)
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js